import { MESApiService } from "@dexteel/mesf-core";

export const getAssets = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[MES].[GetAssets]", []);
};
